import { Injector } from '@angular/core';

export class AppModuleInjector {
  public static injector: Injector;
}
